import { PencilLine } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';

const RequestChangesTooltip = () => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button variant="outline" disabled>
              <PencilLine /> Request changes
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          align="center"
          className="max-w-50 bg-white text-sm text-popover-foreground shadow-md border-border"
        >
          Change requests pending
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RequestChangesTooltip;
